import { RelatorioEmailPdfDataResponse } from "core/features/relatorios/typings";
import { PDFRelatorioBase } from "ui/components/PDF";
import useRelatorioEmailPdfColumns from "./../hooks/useRelatorioEmailPdfColumns";

export interface PDFRelatorioEmailProps {
  relatorioData?: RelatorioEmailPdfDataResponse;
}

function PDFRelatorioEmail({ relatorioData }: PDFRelatorioEmailProps) {
  const columns = useRelatorioEmailPdfColumns();

  return (
    <PDFRelatorioBase
      title="Relatório de emails enviados"
      relatorioData={{
        ...relatorioData!,
        items: relatorioData?.emails ?? [],
      }}
      includeMinHeight={!relatorioData?.assinaturas?.length}
      columns={columns}
    />
  );
}

export default PDFRelatorioEmail;
